import { render, staticRenderFns } from "./data-management-table.vue?vue&type=template&id=3f65d830&scoped=true"
import script from "./data-management-table.vue?vue&type=script&lang=ts"
export * from "./data-management-table.vue?vue&type=script&lang=ts"
import style0 from "./data-management-table.vue?vue&type=style&index=0&id=3f65d830&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f65d830",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f65d830')) {
      api.createRecord('3f65d830', component.options)
    } else {
      api.reload('3f65d830', component.options)
    }
    module.hot.accept("./data-management-table.vue?vue&type=template&id=3f65d830&scoped=true", function () {
      api.rerender('3f65d830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-management-overview/data-management-table.vue"
export default component.exports